import React from 'react';
import './print.css'; 
import moment from 'moment';
// Tailwind classes can be added directly in the component for HTML rendering.

const Invoice = ({data}:any) => {

  return (
    <div className="print:color-accurate">
      <div className="max-w-2xl mx-auto">
        
        {/* First Row: Logo and Title */}
        <div className="flex justify-between items-center mb-4 border-b-1 border-grey-100">
          <div>
            {/* Replace with your logo */}
            <img src={data?.company_info?.logo} alt="Company Logo" className="h-12" />
          </div>
          <div>
            <h2 className="text-2xl font-bold">Invoice</h2>
          </div>
        </div>

        {/* Second Row: Invoice Date and Invoice Number */}
        <div className="flex justify-between items-center mb-8 border-b-1 pb-4 border-grey-100">
          <div>
            <p className="text-gray-600">Date: {moment(data?.billing_address?.created_at).format('MMMM D, YYYY h:mm A')}</p>
          </div>
          <div>
            <p className="text-gray-600">Invoice No: INVOORD-{data.id}</p>
          </div>
        </div>
       
        {/* Third Row: Invoiced To and Pay To (proper alignment) */}
        <div className="flex justify-between items-start mb-8">
          {/* Invoiced To */}
          <div className="text-left">
            <h4 className="text-lg font-bold mb-2">Invoiced To:</h4>
            <p>{data?.billing_address?.first_name}</p>
            <p>{data?.billing_address?.phone_number}</p>
            <p>{data?.billing_address?.street_address} {data?.billing_address?.postal_code}</p>
            <p>{data?.billing_address?.city}, {data?.billing_address?.state}, {data?.billing_address?.country}</p>
          </div>

          {/* Pay To */}
          <div className="text-right">
            <h4 className="text-lg font-bold mb-2">Pay To:</h4>
            <p>{data?.company_info?.company_name}</p>
            <p>{data?.company_info?.address}</p>
            <p>{data?.company_info?.address}</p>
            <p>{data?.company_info?.contact_email}</p>
          </div>
        </div>

        {/* Table */}
        <div className="mb-8">
          <table className="min-w-full table-auto border-collapse">
            <thead className='border-1 bg-gray-100'>
              <tr>
                <th className="px-4 py-2 text-left">Description</th>
                <th className="px-4 py-2 text-right">Rate</th>
                <th className="px-4 py-2 text-right">QTY</th>
                <th className="px-4 py-2 text-right">Amount</th>
              </tr>
            </thead>
            <tbody className='border-1'>
              {data?.items?.map((item:any, index:any)=>(
              <tr key={index} className="border-b">
                <td className="px-4 py-2">{item?.variant?.product_name}</td>
                <td className="px-4 py-2 text-right">{item?.price_per_unit}</td>
                <td className="px-4 py-2 text-right">{item?.quantity}</td>
                <td className="px-4 py-2 text-right">{item?.total_price}</td>
              </tr>))}
             
              {/* Summary Row */}
              <tr className='border-1 bg-gray-100'>
                <td colSpan={3} className="px-4 py-2 text-right font-bold">Sub Total:</td>
                <td className="px-4 py-2 text-right">{data?.total_price}</td>
              </tr>
              <tr className='border-1 bg-gray-100'>
                <td colSpan={3} className="px-4 py-2 text-right font-bold">Discount:</td>
                <td className="px-4 py-2 text-right">{data?.total_discounted_amount}</td>
              </tr>
              <tr className='border-1 bg-gray-100'>
                <td colSpan={3} className="px-4 py-2 text-right font-bold">Shipping Fee:</td>
                <td className="px-4 py-2 text-right">{data?.total_shipping_cost}</td>
              </tr>
              <tr className='border-1 bg-gray-100'>
                <td colSpan={3} className="px-4 py-2 text-right font-bold">Tax:</td>
                <td className="px-4 py-2 text-right">{data?.total_tax}</td>
              </tr>
              <tr className='border-1 bg-gray-100'>
                <td colSpan={3} className="px-4 py-2 text-right font-bold">Total:</td>
                <td className="px-4 py-2 text-right font-bold">{data?.total_price}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="text-center text-gray-600 text-sm">
          <p>This is a computer-generated receipt and does not require a physical signature.</p>
          <p className="text-gray-600">UID Reference: {data.alias}</p>
        </div>
        
      </div>
    </div>
  );
};

export default Invoice;
